<template id="pins">
  <ac-circular-progress
    :loading="loading"
    message="Loading..."
    size="64"
    :width="3"
    color="grey"
    indeterminate
  >
    <v-layout column>
      <v-subheader>Pins: {{ filteredPins.length }}</v-subheader>
      <pins-list :pins="filteredPins" :action="action" @onSelect="onSelect"/>
    </v-layout>

    <ac-delete-dialog
      v-model="confirm"
      :itemName="selectedPin.pin"
      :confirmationCode="selectedPin.pin"
      :onConfirm="onConfirmDelete"
    />

    <v-fab-transition v-if="permission">
      <v-btn class="accent" fab fixed right bottom @click="onAdd">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
  </ac-circular-progress>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PinsList from './pins-list';

export default {
  name: 'pins',
  data: () => ({
    loading: false,
    confirm: false,
    selectedPin: {},
    acl: ['admin', 'developer'],
  }),
  components: {
    PinsList,
  },
  computed: {
    ...mapGetters({
      inRoles: 'Acacia/Profile/inRoles',
      AcaciaSearch: 'AcaciaSearch',
      pins: 'pins',
    }),
    filteredPins() {
      if (!this.AcaciaSearch) return this.pins;
      return this.pins
        .filter(pin =>
          this.checkFilter(pin.pin, this.AcaciaSearch) ||
          this.checkFilter(pin.protocol, this.AcaciaSearch) ||
          this.checkFilter(pin.host, this.AcaciaSearch) ||
          this.checkFilter(`${pin.port}`, this.AcaciaSearch));
    },
    action() {
      return {
        icon: 'delete',
        handler: this.onDelete,
      };
    },
    permission() {
      return this.inRoles(this.acl);
    },
  },
  created() {
    this.loadPins();
    this.setAcaciaToolbar({ title: 'Pins', search: true });
  },
  methods: {
    ...mapActions([
      'addSnackbarErrorHandler',
      'setAcaciaToolbar',
      'getPins',
      'deletePin',
    ]),
    loadPins() {
      this.loading = true;
      this.getPins()
        .then(() => {
          this.loading = false;
        }, (error) => {
          this.loading = false;
          this.addSnackbarErrorHandler(error);
        });
    },
    onSelect(pin) {
      this.$router.push({ name: 'Pin', params: { pinRef: pin.pin } });
    },
    onAdd() {
      this.$router.push({ name: 'Pin', params: { pinRef: 'new' } });
    },
    onDelete(pin) {
      this.selectedPin = pin;
      this.confirm = true;
    },
    onConfirmDelete() {
      this.deletePin(this.selectedPin.pin)
        .then(() => this.addSnackbar({ message: 'PIN Deleted' }))
        .catch(this.addSnackbarErrorHandler);
    },
    checkFilter(value, filter) {
      return value && value.toLowerCase().includes(filter.toLowerCase());
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pin/pins.vue